// Third Party Component
import axiosServices from "@pma/utils/axios"

// Routes
import {
  ACTIVITIES_LIKE,
  ACTIVITIES_UNLIKE,
  GET_ACTIVITIES_LIST,
  NOTES_ADD_ENDPOINT,
} from "@pma/utils/api-routes"

export const getActivitiesListService = async (data: any) => {
  const response: any = await new Promise((resolve, reject) => {
    axiosServices
      .post(GET_ACTIVITIES_LIST, data)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const likeActivityService = async (data: any) => {
  const response: any = await new Promise((resolve, reject) => {
    axiosServices
      .post(ACTIVITIES_LIKE, data)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const unlikeActivityService = async (data: any) => {
  const response: any = await new Promise((resolve, reject) => {
    axiosServices
      .post(ACTIVITIES_UNLIKE, data)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const createUpdatedLogReplyNoteService = async (data: any) => {
  const response: any = await new Promise((resolve, reject) => {
    axiosServices
      .post(NOTES_ADD_ENDPOINT, data)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}
